import GetStarted from './GetStarted';

export default GetStarted;